import React from "react";
import { Card, CardContent, makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles((_theme: Theme) => ({
  card: {
    width: "150px",
    height: "135px",
  },
  content: {
    color: "white",
    fontWeight: "bold",
    padding: "20px",
  },
  sliValue: {
    textAlign: "center",
    fontSize: "20px",
    fontWeight: "bold",
  },
  target: {
    textAlign: "center",
  },
}));

interface Props {
  sloHistory: any;
}

export const DatadogSloCard: React.FC<Props> = ({
  sloHistory,
}): JSX.Element => {
  const classes = useStyles();

  const { attributes, id } = sloHistory.data;

  const overallStatus = attributes.overall_status[0];

  if (overallStatus.error) {
    return (
      <a
        href={`https://app.datadoghq.com/slo?timeframe=7d&slo_id=${id}`}
        target="_blank"
      >
        <Card className={classes.card}>
          <CardContent
            style={{ backgroundColor: "orange" }}
            className={classes.content}
          >
            <p className={classes.sliValue}>ERROR</p>
            <p className={classes.target}>Error in Datadog</p>
          </CardContent>
        </Card>
      </a>
    );
  }

  const threshold: any = attributes.thresholds.find((t: any) => {
    return t.timeframe === "7d";
  });
  const precision: number = overallStatus.span_precision || 2;

  let background: string;
  let display: string;
  let value: string;

  if (threshold?.target && threshold?.target_display && overallStatus.status) {
    const factor = Math.pow(10, precision);
    const statusValue = Math.floor(overallStatus.status * factor) / factor;
    background = statusValue >= threshold.target ? "#00AB66" : "red";
    display = `${threshold.target_display}%`;
    value = `${statusValue}%`;
  } else {
    value = "N/A";
    background = "gray";
    display = "N/A";
  }

  return (
    <a
      href={`https://app.datadoghq.com/slo?timeframe=7d&slo_id=${id}`}
      target="_blank"
    >
      <Card className={classes.card}>
        <CardContent
          style={{ backgroundColor: background }}
          className={classes.content}
        >
          <p className={classes.sliValue}>{value}</p>
          <p className={classes.target}>Target: {display}</p>
        </CardContent>
      </Card>
    </a>
  );
};
